import services from "../../../views/Orders/services";
import { EstimateSplitPatchPayload } from "./estimateSplitPatchPayload";

export type EstimateSplitPatchRequest = {
  splitId: string;
  payload: EstimateSplitPatchPayload;
};

export async function applyEstimateSplitPatchesSequentially(
  estimateNo: string,
  patches: EstimateSplitPatchRequest[],
): Promise<unknown | null> {
  let lastEstimate: unknown = null;
  for (const { splitId, payload } of patches) {
    lastEstimate = await services.patchEstimateSplit(
      estimateNo,
      splitId,
      payload,
    );
  }
  return lastEstimate;
}
